import { Component, type ErrorInfo, type PropsWithChildren, type ReactNode } from 'react'
import { PrimaryButton, SecondaryButton } from '@/components/Button'

interface AppErrorBoundaryState {
  hasError: boolean
}

interface AppErrorBoundaryProps extends PropsWithChildren {
  fallback?: ReactNode
}

export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  public override state: AppErrorBoundaryState = { hasError: false }

  public static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true }
  }

  public override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Falha capturada pela barreira global.', { error, errorInfo })
  }

  private readonly reset = () => this.setState({ hasError: false })

  public override render() {
    if (!this.state.hasError) {
      return this.props.children
    }

    if (this.props.fallback) {
      return this.props.fallback
    }

    return (
      <main className="fatal-error" role="alert">
        <span className="eyebrow">Erro do aplicativo</span>
        <h1>Não foi possível exibir esta tela</h1>
        <p>Os dados locais não foram enviados. Tente novamente ou recarregue o aplicativo.</p>
        <div className="button-row">
          <SecondaryButton onClick={this.reset}>Tentar novamente</SecondaryButton>
          <PrimaryButton onClick={() => window.location.reload()}>Recarregar</PrimaryButton>
        </div>
      </main>
    )
  }
}
